import {
    IonPage, IonContent, IonInput, IonTitle, IonAlert
} from '@ionic/react';
import React, {Component} from "react";
import './css/style.css';
import {withRouter} from "react-router-dom";
import {accountCancel} from "./Service";
import cookieUtil from "../../../../utils/cookieUtil";
import {getQueryVariable} from "../../../../utils/commonFunction";


class AccountCancellation extends Component {

    constructor(props) {
        super(props);
        this.state = {
            phone: '',
            phoneTip: 0,
            code: '',
            codeTip: null,
            agreementTip: true,
            scriptLoaded: false,
            showTipModal: false,
            getCodeMsg: "获取验证码",
            showNoticeTip: false,
            isPicUpload: false,
            djs: '',
            isAgree: false,
            token: null,
            reason: '',
            btnAllow: true,
            hidStr: ''
        }
    }

    regPhone = new RegExp(/^[1][3,4,5,6,7,8,9][0-9]{9}$/)
    regCode = new RegExp(/^[0-9]{6}$/)

    componentDidMount() {
        if (cookieUtil.has("access_token")) {
            this.setState({token: cookieUtil.get("access_token")})
        }
        if (cookieUtil.has("userInfo")) {
            let userInfoJson = JSON.parse(cookieUtil.get("userInfo"))
            //console.log(userInfoJson);
            this.setState({account: userInfoJson.userGameId})
        }
        // 兼容公众号个人中心--帐号注销跳转至该页面
        let userGameId = getQueryVariable('userGameId');
        if (userGameId !== null && userGameId !== '' && userGameId !== '0') {
            this.setState({account: userGameId})
        }
        let hidStrParam = getQueryVariable('hidStr');
        if (hidStrParam !== null && hidStrParam !== '') {
            this.setState({hidStr: hidStrParam})
        }
    }

    setPhone = (e) => {
        this.setState({phone: e, phoneTip: 0})
    }
    checkPhone = () => {
        const {phone} = this.state;
        let phoneTip = 0;
        if (!this.regPhone.test(phone)) {
            phoneTip = 1;
        }
        console.log('phoneTip====' + phoneTip)
        this.setState({
            phoneTip: phoneTip,
        })

    }

    setCode = (e) => {
        let codeTip = 0;
        if (this.regCode.test(e)) {
            codeTip = 1
        }

        this.setState({
            code: e,
            codeTip: codeTip
        })
    }

    showNotice = () => {
        const {showNoticeTip} = this.state;
        this.setState({
            showNoticeTip: !showNoticeTip
        })
    }

    closeTipBox = () => {
        this.setState({
            isShowTip: false,
            showTipMsg: null
        })
    }
    /**
     * 原因页面展示
     * @param type
     */
    uploadPage = (type) => {
        this.setState({
            isPicUpload: true,
            picType: type
        })
    }

    returnPage = () => {
        this.setState({isPicUpload: false})
    }

    setReason = () => {
        const reasonCheckBoxs = document.getElementsByName('reason');
        let reason = '';
        for (let i = 0; i < reasonCheckBoxs.length; i++) {
            if (reasonCheckBoxs[i].checked) {
                if (reason.length === 0) {
                    reason = reasonCheckBoxs[i].value;
                    continue;
                }
                reason = reason + "," + reasonCheckBoxs[i].value;
            }
        }
        console.log(reason)
        this.setState({"reason": reason})
    }

    submitAccountCancel = () => {
        this.setState({
            btnAllow: false
        })
        const {token, account, isAgree, idCard, realName, reason, hidStr} = this.state;

        if (!isAgree) {
            this.setState({
                isShowTip: true,
                showTipMsg: "请仔细阅读并同意《游戏账号注销协议》。",
                btnAllow: true
            })
        }
        if (account === '') {
            this.setState({
                isShowTip: true,
                showTipMsg: '请填写游戏账号',
                btnAllow: true
            })
            return;
        }

        if (realName === '' || idCard === '') {
            this.setState({
                isShowTip: true,
                showTipMsg: '请填写真实身份证信息',
                btnAllow: true
            })
            return;
        }

        // if (reason === '') {
        //     this.setState({
        //         isShowTip: true,
        //         showTipMsg: '请填写注销理由',
        //         btnAllow: true
        //     })
        //     return;
        // }

        const params = {
            'access_token': token,
            'realName': realName,
            'accounts': account,
            'idCard': idCard,
            'applyReason': "",
            'hidStr': hidStr
        };

        accountCancel(params).then(ret => {
            if (ret.code === '10000') {
                this.setState({
                    isShowTip: true,
                    showTipMsg: '您已成功提交注销申请，账号注销中，保留15个自然日（犹豫期），15天后账号自动注销。',
                    btnAllow: true
                })
            } else {
                this.setState({
                    isShowTip: true,
                    showTipMsg: ret.msg,
                    btnAllow: true
                })
            }
        }).catch(err => {
            console.log(err);
            this.setState({
                btnAllow: true
            })
        });
    }

    render() {

        const {showNoticeTip, isAgree, idCard, account, isPicUpload, reason, btnAllow} = this.state;

        return (
            <IonPage>
                <IonContent fullscreen>
                    {isPicUpload ?
                        <div className="sut_cont bggray">
                            <div className="phone_top pr">
                                <a className="xya_return" onClick={() => this.returnPage()}>
                                    <img src={require("../../../images/member/refund/return_icon.png")}/>
                                </a>
                                <div className="top_title">注销原因</div>
                            </div>
                            <div className="sut_box">
                                <div className="clearfix pt30">
                                    <div className="sut_list">
                                        <div className="radio_cont_kf clearfix">
                                            <label>
                                                <input type="checkbox" value="工作繁忙，无时间游戏" name="reason"
                                                       checked={reason.indexOf("工作繁忙，无时间游戏") !== -1}
                                                       onChange={() => this.setReason()}/>工作繁忙，无时间游戏</label>
                                            <label>
                                                <input type="checkbox" value="体验其它趣味爱好，无时间游戏" name="reason"
                                                       checked={reason.indexOf("体验其它趣味爱好，无时间游戏") !== -1}
                                                       onChange={() => this.setReason()}/>体验其它趣味爱好，无时间游戏</label>
                                            <label>
                                                <input type="checkbox" value="长期不登录" name="reason"
                                                       checked={reason.indexOf("长期不登录") !== -1}
                                                       onChange={() => this.setReason()}/>长期不登录</label>
                                            <label>
                                                <input type="checkbox" value="其它原因" name="reason"
                                                       checked={reason.indexOf("其它原因") !== -1}
                                                       onChange={() => this.setReason()}/>其它原因</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div> :
                        <div className="sut_cont bggray">
                            <div className={"phone_top pr border-bottom-e6"}>
                                <div className="top_title">账号注销</div>
                            </div>
                            <div className="cont_kf">
                                <div className="point_tex">
                                    <p>账号一旦注销将无法予以找回，同时账号信息予以删除处理，请您知晓。</p></div>
                                <div className="phone_identity clearfix">
                                    <span className="w300">* 游戏账号或ID</span>
                                    <input type="text" className="input-tex4" placeholder="第三方账号请填写游戏ID"
                                           value={this.state.account}
                                           onChange={e => this.setState({account: e.target.value})}/>
                                </div>
                                <div className="phone_identity clearfix">
                                    <span className="w300">* 账号实名认证姓名</span>
                                    <input type="text" className="input-tex4" placeholder="请输入真实姓名"
                                           value={this.state.realName}
                                           onChange={e => this.setState({realName: e.target.value})}/>
                                </div>
                                <div className="phone_identity clearfix">
                                    <span className="w300">* 账号实名身份证号</span>
                                    <input type="text" className="input-tex4" placeholder="请输入有效身份证号码"
                                           value={this.state.idCard}
                                           onChange={e => this.setState({idCard: e.target.value})}/>
                                </div>
                                {/*<div className="phone_identity  upload clearfix pr">*/}
                                {/*    <a className="upload_icon1" onClick={() => this.uploadPage(1)}>*/}
                                {/*        <span className="w300">* 注销原因</span>*/}
                                {/*        <img src={require("../../../images/member/refund/jt_icon.png")}/>*/}
                                {/*    </a>*/}
                                {/*    <p className="upload_tex1 pa">{reason != null && reason.length > 0 ? '已选择' : ''}</p>*/}
                                {/*</div>*/}
                                <div className="Agreed clearfix agreement">
                                    <div onClick={() => this.setState({isAgree: !isAgree})}
                                         className={isAgree ? "on" : "agreed"}>
                                        <div className="choose_tex" style={{marginLeft: "25px"}}>
                                            <span className="textGrey9">我已阅读并接受</span>
                                            <a className="textBlue"
                                               href="https://wfw.fuyuncc.com/pc/accountCancel/CancellationProtocolDetail.html">《游戏账号注销协议》</a>
                                        </div>
                                    </div>
                                </div>
                                <a className="btn_kf" aria-disabled={!btnAllow}
                                   onClick={this.submitAccountCancel}>同意注销</a>
                                {/* <div className="cont_tex">
                                    <div className="cont_tex_title" onClick={this.showNotice}>安全条件</div>
                                    <p className={showNoticeTip ? "hidden_tex" : "dn"}>1、提交注销申请的账号实名认证时长至少一个月以上；<br/>
                                        2、近一个月内账号未进行过密码修改、异地登录等敏感操作；账号未存在申诉、冻结等异常状态；<br/>
                                        3、该账号已解绑91y平台官方公众号。</p>
                                </div>*/}
                            </div>
                        </div>
                    }
                </IonContent>
                <IonAlert
                    isOpen={this.state.isShowTip}
                    onDidDismiss={() => this.closeTipBox()}
                    header="温馨提示"
                    message={this.state.showTipMsg}
                    buttons={['OK']}
                />
            </IonPage>
        );
    }
}

export default withRouter(AccountCancellation);
